import { Client } from '../api-client';

const getTopic = (scheduleId: string) => `user-experience/lecture/subtopic/list/${scheduleId}`;
const getReportTimestampTopicUrl = () => 'v1/enquiry/public-enquiry-ticket';

export const getTimestampTopic = ({ queryKey }: any) => {
  const { scheduleId } = queryKey[1];
  return Client.get(getTopic(scheduleId));
};

export const reportTimestampTopicFetcher = (data: any) => {
  return Client.post(getReportTimestampTopicUrl(), data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    shouldHide: false, // to show notification toast
  });
};
